class UnitConversionUtils {

  static convertTemperature(value, unitFrom, unitTo) {
    if (unitFrom === unitTo) {
      return value;
    }
    if (unitFrom === 'celsius' && unitTo === 'fahrenheit') {
      return (value * 9 / 5) + 32;
    }
    if (unitFrom === 'fahrenheit' && unitTo === 'celsius') {
      return (value - 32) * 5 / 9;
    }
    throw new Error(`Invalid unitFrom "${unitFrom}" and/or unitTo "${unitTo}".`);
  }

}

export default UnitConversionUtils;
